import { Link } from "react-router-dom";
import { ArrowRight, ExternalLink } from "lucide-react";
import { SectionHeader } from "@/components/ui/SectionHeader";
import { Reveal } from "@/components/ui/Reveal";
import { DeadlineStrip } from "@/components/ui/DeadlineStrip";

export const FreeAccessSteps = ({ steps = [], config, availability }) => (
  <section id="free-access" className="gm-section">
    <div className="gm-container">
      <SectionHeader
        eyebrow="Free access"
        title="How to get it for free"
        subtitle="Four steps je. Our broker partnership pays for your licence, so you tak perlu keluar duit for the EA itself."
        align="center"
        testId="free-access-header"
      />

      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map((s, i) => (
          <Reveal key={s.slug || s.no} delay={i * 65}>
            <article
              className="gm-card gm-card-hover h-full"
              data-testid={`free-access-step-${i + 1}`}
            >
              <span className="gm-ring-num">{s.no}</span>
              <h3 className="mt-4 text-base font-bold text-white">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed" style={{ color: "var(--gm-muted)" }}>
                {s.body}
              </p>
            </article>
          </Reveal>
        ))}
      </div>

      <div className="mt-10 mx-auto max-w-2xl">
        <DeadlineStrip availability={availability} testId="free-access-deadline-strip" />
      </div>

      <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
        <Link
          to="/free-access"
          data-testid="free-access-apply-cta"
          className="gm-btn-red inline-flex min-h-[50px] items-center justify-center gap-2 rounded-xl px-6 text-sm font-bold"
        >
          Apply for free access
          <ArrowRight className="h-4 w-4" />
        </Link>
        <a
          href={config?.broker_signup_url || "#"}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="free-access-broker-cta"
          className="gm-btn-ghost inline-flex min-h-[50px] items-center justify-center gap-2 rounded-xl px-6 text-sm font-semibold"
        >
          Register with the broker
          <ExternalLink className="h-4 w-4" />
        </a>
      </div>
      <p
        className="mt-4 text-center text-xs"
        data-testid="free-access-existing-note"
        style={{ color: "var(--gm-muted-2)" }}
      >
        Already have an account with that broker? Message us on Telegram - we check
        case by case.
      </p>
    </div>
  </section>
);
